export const placementHelpCenter = {
    tutorialsUrl: "https://docs.seniorplace.io",
    beaconId: "16c639c8-f76a-413e-9a18-5efab05bd76c",
    articles: {
        smtp: "/article/130-how-to-set-up-direct-email-smtp",
        calendar: "/article/48-how-to-add-senior-place-tasks-to-your-calendar",
        pdfForSignWise: "/article/173-how-to-convert-your-document-to-pdf-for-signwise",
        masterTheBasics: "/article/101-master-the-basics-top-tutorials-for-new-users",
    },
};
export const homeCareHelpCenter = {
    tutorialsUrl: "https://home-care-docs.seniorplace.io",
    beaconId: "3fe8f6d0-1a08-4987-9d2f-8de5aa680421",
    articles: {
        smtp: "/article/447-how-to-set-up-direct-email-smtp",
        calendar: "/article/411-how-to-add-senior-place-tasks-to-your-calendar",
        pdfForSignWise: "/article/457-how-to-convert-your-document-to-pdf-for-signwise",
        masterTheBasics: "/article/437-master-the-basics-top-tutorials-for-new-users",
    },
};
export const combinedHelpCenter = {
    tutorialsUrl: "https://docs-all.seniorplace.io",
    beaconId: "81c5f89e-cb05-46e1-a3d7-5b79fbd9baa2",
    articles: {
        smtp: "/article/335-how-to-set-up-direct-email-smtp",
        calendar: "/article/266-how-to-add-senior-place-tasks-to-your-calendar",
        pdfForSignWise: "/article/360-how-to-convert-your-document-to-pdf-for-signwise",
        masterTheBasics: "/article/311-master-the-basics-top-tutorials-for-new-users",
    },
};
export const helpCenterForCrmMode = (mode) => {
    switch (mode) {
        case "placement-only":
            return placementHelpCenter;
        case "home-care-only":
            return homeCareHelpCenter;
        case "combined":
        case "none":
            return combinedHelpCenter;
    }
    const exhaustiveCheck = mode;
    throw new Error(`Unhandled CRM mode ${String(exhaustiveCheck)}`);
};
export const helpCenterArticleUrl = (helpCenter, article) => `${helpCenter.tutorialsUrl}${helpCenter.articles[article]}`;
//# sourceMappingURL=help-center.js.map